import { TDownloadLaborPosterTemplateRequestSchema } from "./downloadLaborPosterTemplate.schema";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

const DOWNLOAD_LABOR_POSTER_TEMPLATE_TIMEOUT_MS = 300000;

export const downloadLaborPosterTemplate = (axios: IAxiosInstance) => {
  return async (
    payload: TDownloadLaborPosterTemplateRequestSchema
  ): Promise<Blob> => {
    const response = await axios.noRetry.post<Blob>(
      `/labor-posters/template`,
      payload,
      {
        responseType: "blob",
        timeout: DOWNLOAD_LABOR_POSTER_TEMPLATE_TIMEOUT_MS,
      }
    );

    return response.data;
  };
};
